module.exports = __webpack_public_path__ + "privateAssetLabSlideoutAsset2.0f5583aeee28cae2c761372d3ef6ffac.png";